import { useCustomerViewSate } from "api/admin/customerView";
import { useEffect } from "react";
import { HiMiniWrenchScrewdriver } from "react-icons/hi2";
import { useNavigate } from "react-router-dom";

export default function UnderMaintenance() {
  const { data, isSuccess, isLoading } = useCustomerViewSate();
  const navigate = useNavigate();

  useEffect(() => {
    if (isSuccess && !isLoading && !data?.maintenance) {
      navigate("/control-panel");
    }
  }, [data?.maintenance, isLoading, isSuccess, navigate]);

  return (
    <div className="portal-shell relative min-h-full overflow-hidden px-4 flex  items-center justify-center py-8">
      <div className="pointer-events-none absolute inset-0 overflow-hidden">
        <div className="absolute left-1/2 top-24 h-72 w-72 -translate-x-1/2 rounded-full bg-[rgba(255,178,91,0.18)] blur-3xl" />
        <div className="absolute bottom-16 left-1/2 h-56 w-56 -translate-x-1/2 rounded-full bg-[rgba(229,106,0,0.14)] blur-3xl" />
      </div>

      <div className="relative m-auto flex h-full max-w-3xl items-center justify-center">
        <div className="portal-panel m-auto w-full rounded-[2rem] px-6 py-10 text-center sm:px-10 sm:py-14">
          <div className="mx-auto mb-6 flex h-24 w-24 items-center justify-center rounded-[2rem] border border-[rgba(255,139,31,0.18)] bg-[linear-gradient(135deg,rgba(255,244,230,0.78),rgba(255,178,91,0.18))] text-[var(--layout-accent)] shadow-[0_24px_60px_rgba(229,106,0,0.18)] dark:bg-[linear-gradient(135deg,rgba(91,36,0,0.38),rgba(255,139,31,0.16))]">
            <HiMiniWrenchScrewdriver className="h-10 w-10" />
          </div>

          <h1 className="mb-4 text-3xl font-black text-[var(--layout-text)] sm:text-5xl">
            الموقع قيد الصيانة
          </h1>

          <p className="mx-auto max-w-xl text-sm leading-8 text-[var(--layout-text-muted)] sm:text-base">
            نعمل حالياً على تحسين الخدمة وسنعود قريباً.
          </p>
        </div>
      </div>
    </div>
  );
}
